import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/common';
import InviteUsersModal from 'src/shared/InviteUsersModal';

export const InviteUsers: FC = () => {
  const { t } = useTranslation();

  const [modalVisible, setModalVisible] = useState(false);

  const onShowModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  const onHideModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <>
      <Button onClick={onShowModal} type={'primary'}>
        {t('Teammates.inviteTeammates')}
      </Button>
      {modalVisible && <InviteUsersModal onHide={onHideModal} />}
    </>
  );
};

export default InviteUsers;
